// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import { getDocumentsWrapper } from "@store/Framework/Common/Utilities/getDocumentsWrapper";
import useTrackExportHistory from "@store/Framework/GoogleAnalytics/hooks/useTrackExportHistory";
import { getDropTrailerExport } from "@store/Framework/Services/documentService";
import {
    useTrailerTrackingV2DataView,
    useTrailerTrackingV2State,
} from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/TrailerTrackingV2Hooks";
import { tableFilterProps } from "@store/Themes/common/props/table";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC, useContext, useState } from "react";
import { css } from "styled-components";

export interface TrailerTrackingV2DownloadLinkStyles {
    wrapper?: InjectableCss;
    link?: LinkPresentationProps;
    loadingLink?: LinkPresentationProps;
    tooltip?: TooltipPresentationProps;
}

export const trailerTrackingV2DownloadLinkStyles: TrailerTrackingV2DownloadLinkStyles = {
    wrapper: {
        css: css`
            display: inline-flex;
            align-items: center;
            ${inlineSeparatorStyles({ spacing: pxToRem(20), color: "common.borderLight" })}
        `,
    },
    link: tableFilterProps.exportLink,
    loadingLink: tableFilterProps.exportLoadingLink,
    tooltip: tableFilterProps.exportTooltip,
};

const styles = trailerTrackingV2DownloadLinkStyles;

const TrailerTrackingV2DownloadLink: FC = () => {
    const { parameter } = useTrailerTrackingV2State();
    const { filteredTrailerCount, isLoading } = useTrailerTrackingV2DataView();
    const [isExporting, setIsExporting] = useState(false);
    const toasterContext = useContext(ToasterContext);
    const trackExportHistory = useTrackExportHistory();

    const isDisabled = isExporting || isLoading || !filteredTrailerCount;

    const handleExport = () => {
        if (isDisabled) {
            return;
        }

        getDocumentsWrapper(getDropTrailerExport, { parameter }, { stateSetter: setIsExporting, toasterContext }).then(
            success => {
                if (success) {
                    trackExportHistory({ file_category: "DropTrailer export" });
                }
            },
        );
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <Link
                {...(isExporting ? styles.loadingLink : styles.link)}
                disabled={isDisabled}
                onClick={handleExport}
                data-test-selector="trailerTrackingV2_exportLink"
            >
                {translate("Export Drop Trailer Data")}
            </Link>
            <Tooltip {...styles.tooltip} text={siteMessage("DropTrailer_Export_ToolTip").toString()} />
        </StyledWrapper>
    );
};

export default TrailerTrackingV2DownloadLink;
